import PeopleHierarchy from "../../../../components/company/organization/people-hierarchy"

export default function PeopleHierarchyPage(){
    return <PeopleHierarchy />
}